import { render, staticRenderFns } from "./MaterialInputField.vue?vue&type=template&id=8f470724&scoped=true&"
import script from "./MaterialInputField.vue?vue&type=script&lang=ts&"
export * from "./MaterialInputField.vue?vue&type=script&lang=ts&"
import style0 from "./MaterialInputField.vue?vue&type=style&index=0&id=8f470724&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f470724",
  null
  
)

export default component.exports